var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "\n    w-full\n    transition-colors\n    flex\n    md:text-xl\n    items-center\n    justify-center\n    md:w-auto md:inline-flex\n    py-3.5\n    md:py-3\n    px-7\n    font-bold\n    md:mt-5\n  ",
      class: _vm.isDisabled
        ? "bg-velux-grey-300 text-velux-grey-900 pointer-events-none"
        : "bg-velux-red text-velux-white hover:bg-velux-hover-red",
      attrs: {
        role: "button",
        tabindex: "0",
        disabled: _vm.isDisabled,
        "aria-disabled": _vm.isDisabled
      }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }